import { z } from 'zod'

export const importPaymentsRequestSchema = z.object({
  dividendCategoryId: z.string().nullable().optional(),
  couponCategoryId: z.string().nullable().optional(),
  operationIds: z.array(z.string()).min(1),
})

export type ImportPaymentsRequestDto = z.infer<typeof importPaymentsRequestSchema>
